import Api from '../Helper/Api';
import axios from 'axios';

class SportAction {

    cricket(data) {

        let resp = Api.postApi(data, 'cricket-scorecard');
        // console.log("cricket-api-resp-from-NODE",resp);
        return resp

    }

    testcricket(params) {

        // let url = "https://rest.entitysport.com/v2/matches/"+params.match_id+"/scorecard?token=d47ce3f84f0995d66e1aba38f68d6c19" 
        // // let url = "https://app-stage.editorji.com/cricket-scorecard"+params.match_id+"/scorecard?token=d47ce3f84f0995d66e1aba38f68d6c19" 
        // const options = {
        //     method: 'GET',
        //     url,
        // };
        // return axios(options)
      
        let resp = Api.postApi(params, 'cricket-scorecard');
        // console.log("cricket-scorcard-resp",resp);
        return resp
    }



}

export default SportAction.prototype;